export default __webpack_public_path__ + "static/media/beecitylogo.54aaabea.png";